module.exports = __webpack_public_path__ + "img/current_on.1cc91fab.png";